import { IPromise } from 'angular'
import { ApiStoreCredit, ApiStoreCreditTransaction } from '@vend/types'

import { $http } from '../../../ng-compat/imports'

const STORE_CREDIT_ENDPOINT = '/api/2.0/store_credits'

interface StoreCreditData {
  type: string
  amount: number
  notes: string | null
  user_id: string
  client_id: string | null
}

/**
 * Functions for querying the Store Credits API
 */

/**
 * Get the given customer's store credit details from the API.
 *
 * @param customerId
 *        Identifies the customer
 *
 * @return A promise resolved when the customer store credit object has been retrieved
 */
export function getCustomerStoreCredit(
  customerId: string
): IPromise<ApiStoreCredit> {
  return $http
    .get<ApiStoreCredit>(`${STORE_CREDIT_ENDPOINT}/${customerId}`)
    .then(response => response.data)
}

/**
 * Records a store credit transaction for a given customer.
 *
 * @param customerId
 *        Identifies the customer
 *
 * @param storeCreditData
 *        The data of the store credit transaction to record
 *
 * @return A promise resolved when the store credit transaction has been recorded
 */
export function recordStoreCredit(
  customerId: string,
  storeCreditData: StoreCreditData
): IPromise<ApiStoreCreditTransaction> {
  return $http
    .post<ApiStoreCreditTransaction>(
      `${STORE_CREDIT_ENDPOINT}/${customerId}/transactions`,
      storeCreditData
    )
    .then(response => response.data)
}
